import createSagaMiddleWare from 'redux-saga';

import { routerMiddleware } from 'connected-react-router/immutable';
import { forOwn } from 'lodash-es';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import Sagas from '../Services/Sagas';

import initialState from './initialState';
import rootReducer from './rootReducer';

import { checkTokenExpirationMiddleware } from './checkTokenExpirationMiddleware';
import { dynamicMiddlewares } from './customer/middleware-wrapper';
import { themeMiddleware } from './middleware/themeMiddleware';

const sagaMiddleware = createSagaMiddleWare();
const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

const configureStore = history => {
  let middlewares = [
    checkTokenExpirationMiddleware,
    sagaMiddleware,
    themeMiddleware,
    routerMiddleware(history), // for dispatching history actions,
  ];
  forOwn(dynamicMiddlewares, middleware => {
    middlewares = [...middlewares, middleware(history)];
  });
  const store = createStore(
    rootReducer(history),
    initialState(history),
    composeEnhancers(applyMiddleware(...middlewares)),
  );
  sagaMiddleware.run(Sagas);
  return store;
};

export default configureStore;
